import type { Coordinates } from 'modules/org_chart/models/Coordinates'

interface Curve {
  source: Coordinates
  target: Coordinates
}

type Direction = 'center' | 'left' | 'right'

const curveSize = 20

export default (curve: Curve): string => {
  const { source, target } = curve
  const [sourceX, sourceY] = source
  const [targetX, targetY] = target

  const direction = getDirection(sourceX, targetX)
  const directionedCurveX = getDirectionedValue(direction, curveSize)
  const finalX = directionedCalcule(direction, targetX, 40)
  const finalY = getRelativeCoordinate(sourceY, targetY) - 40

  return `
    M${sourceX},${sourceY}
    q 0,${curveSize} ${directionedCurveX},${curveSize}
    0,0 ${getRelativeCoordinate(sourceX, finalX)},0
    q ${directionedCurveX},0 ${directionedCurveX},${curveSize}
    0,0 0,${finalY}
  `
}

const getDirection = (sourceX: number, targetX: number): Direction => {
  if (sourceX === targetX) return 'center'
  else if (sourceX < targetX) return 'right'
  else return 'left'
}

const getDirectionedValue = (direction: Direction, value: number): number => {
  switch (direction) {
    case 'center':
      return 0
    case 'left':
      return -value
    default:
      return value
  }
}

const directionedCalcule = (direction: Direction, source: number, target: number): number => {
  switch (direction) {
    case 'center':
      return source
    case 'left':
      return source + target
    default:
      return source - target
  }
}

const getRelativeCoordinate = (source: number, target: number): number => {
  const direction = getDirection(source, target)

  switch (direction) {
    case 'center':
      return 0
    default:
      return target - source
  }
}
